import { RollingRowSettings } from '@features/dashboard/widgets/shared/types';
import { TradeLimit } from '@protos/user';
import { OrderType } from '@protos/v2/order';
import { OrderNotification } from '@shared/contexts/OrderNotificationsContexts';
import { ProductGroupEnum } from '@protos/options';
export interface CellStyle {
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
}

export interface OCLTradingSettings {
  pricingSheet?: {
    selectedColumns?: string[];
    selectedRows?: string[];
    columnsOrder?: string[];
    userRollingRowSettings?: RollingRowSettings;
    isOverrideRolling?: boolean;
    pricesGridCellStyles?: Record<string, CellStyle>;
  };
  mixed?: {
    mixedGridData?: Record<string, any>;
  };
  BidOffer?: {
    nonSpreadGridData?: Record<string, any>;
    spreadGridData?: Record<string, any>;
  };
  orderNotifications?: {
    notificationList?: OrderNotification[];
    isSoundEnabled?: boolean;
    selectedOrderTypes?: OrderType[];
    selectedProductGroups?: ProductGroupEnum[];
  };
  trade_limits?: TradeLimit[];
  trade_accounts?: string[];
  default_trade_sizes?: Record<string, number>;
}

export enum OCLTradingType {
  PRICING = 'pricing',
  MIXED = 'mixed',
  BID_OFFER_ONLY = 'bid-offer-only',
  ORDER_ENTRY = 'order-entry',
  ALL_ORDERS = 'all-orders',
}
